// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1y0Ik","large":"styles_large__21BCe"};